import React, { useState } from 'react';
import MaterialTable from 'material-table';
import { FilterList } from '@material-ui/icons';
import { ActivateItem, EditValueItem, InactivateItem } from '../ActionItems';

/**
 *
 * @param {import('material-table').MaterialTableProps<RowData>} props
 */
const MaterialTableComponent = ({
  options,
  onOrderChange,
  onSearchChange,
  sortableColumns,
  columns,
  data,
  rightTitle,
  callbackFunctionInativar,
  callbackFunctionAtivar,
  callbackFunctionEditValues,
  useServerSideFiltering = false,
  title,
  disableNegativeMargin = false,
  ...rest
}) => {
  const [activeCount, setActiveCount] = useState(0);
  const [inactiveCount, setInactiveCount] = useState(0);
  const [hasSelection, setHasSelection] = useState(false);

  // Verifica se o título está vazio ou é apenas espaços em branco
  const isTitleEmpty =
    !title || (typeof title === 'string' && title.trim() === '');

  // Atualiza o estado da seleção dinamicamente
  React.useEffect(() => {
    const hasSelectedItems = activeCount > 0 || inactiveCount > 0;
    // Só aplica margin negativa se não há título E não há seleção E não está desabilitada
    setHasSelection(hasSelectedItems || !isTitleEmpty || disableNegativeMargin);
  }, [activeCount, inactiveCount, isTitleEmpty, disableNegativeMargin]);

  return (
    <MaterialTable
      title={title}
      style={{
        boxShadow: 'unset',
        margin: 0,
        zIndex: 0,
        fontFamily: 'Nunito',
        marginTop: hasSelection ? '0px' : '-64px',
        ...rest.style
      }}
      data={data}
      onOrderChange={(indexOrderBy, direction) => {
        const selectedColumn = sortableColumns && sortableColumns[indexOrderBy];
        if (selectedColumn) {
          return onOrderChange(selectedColumn, direction);
        }
      }}
      onSelectionChange={rows => {
        setActiveCount(rows.filter(x => x.active === 'Sim').length);
        setInactiveCount(rows.filter(x => x.active === 'Não').length);
        if (rest && rest.onSelectionChange) {
          rest.onSelectionChange(rows);
        }
      }}
      columns={columns}
      onSearchChange={text => onSearchChange && onSearchChange(text.trim())}
      options={{
        paging: true,
        exportButton: false,
        emptyRowsWhenPaging: false,
        pageSize: 10,
        pageSizeOptions: [10, 20, 50, 100],
        debounceInterval: 750,
        padding: 'dense',
        rowStyle: (row, index) => ({
          backgroundColor: index % 2 ? '#FFF' : '#409df70f',
          fontWeight: row.totalRow ? 'bolder' : 'normal',
          color:
            row.active === 'Não'
              ? 'red'
              : row.future === true
                ? 'green'
                : row.disabled === true
                  ? 'gray'
                  : 'black'
        }),
        // Remove o espaço do título quando estiver vazio
        showTitle: !isTitleEmpty,
        // Controla a exibição da toolbar baseado no título e opções
        toolbar:
          options && options.toolbar !== undefined
            ? options.toolbar
            : !isTitleEmpty,
        ...options
      }}
      actions={[
        options && options.selection && callbackFunctionEditValues
          ? {
              tooltip: 'Editar registros selecionados',
              icon: () => <EditValueItem />,
              onClick: (evt, data) => {
                callbackFunctionEditValues(data);
              }
            }
          : null,
        options && options.selection && activeCount > 0 && !inactiveCount
          ? {
              tooltip: 'Inativar registros selecionados',
              icon: () => <InactivateItem />,
              onClick: (evt, data) => {
                callbackFunctionInativar(data);
              }
            }
          : null,
        options && options.selection && inactiveCount > 0 && !activeCount
          ? {
              tooltip: 'Ativar registros selecionados',
              icon: () => <ActivateItem />,
              onClick: (evt, data) => {
                callbackFunctionAtivar(data);
              }
            }
          : null
      ]}
      icons={{
        Search: () => <FilterList />
      }}
      localization={{
        pagination: {
          labelRowsPerPage: 'Linhas por Página:',
          labelRowsSelect: 'linhas',
          labelDisplayedRows: '{from}-{to} de {count}',
          firstAriaLabel: 'Primeira Página',
          firstTooltip: 'Primeira Página',
          previousAriaLabel: 'Página Anterior',
          previousTooltip: 'Página Anterior',
          nextAriaLabel: 'Pŕoxima Página',
          nextTooltip: 'Pŕoxima Página',
          lastAriaLabel: 'Última Página',
          lastTooltip: 'Última Página',
          ...(options && options.localization && options.localization.pagination
            ? options.localization.pagination
            : {})
        },
        toolbar: {
          nRowsSelected: '{0} linha(s) selecionada(s)',
          addRemoveColumns: 'Adicionar ou remover colunas',
          showColumnsTitle: 'Exibir colunas',
          showColumnsAriaLabel: 'Exibir colunas',
          exportTitle: 'Exportar',
          exportAriaLabel: 'Exportar',
          exportName: 'Exportar para .CSV'
        },
        grouping: {
          groupedBy: 'Agrupado por:',
          placeholder: 'Arraste os cabeçalhos aqui para agrupar por:'
        },
        body: {
          emptyDataSourceMessage: 'Nenhum registro encontrado',
          filterRow: {
            filterTooltip: 'Filtrar'
          }
        }
      }}
      {...rest}
    />
  );
};

export default MaterialTableComponent;
